import {
  selectCalendarAndSlots,
  updateCalendarAndSlotsState,
} from '../../../../store/slices/calendarAndSlots';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import classes from './CustomerSlots.module.css';
import CustomDropdown from '../../../../components/UI/Inputs/CustomDropdown';
import moment from 'moment';
import { useTranslation } from '../../../../hooks/useTranslations';

const CustomerSlots: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();

  const calendarAndSlots = useAppSelector<any>(selectCalendarAndSlots);
  let calendarData: any = Array(calendarAndSlots);
  let timeSlots: any = [...calendarData];

  const getTimeSlot = () => {
    return calendarData[0].timeslot_length;
  };
  const getCapacity = () => {
    return calendarData[0].capacity_per_timeslot;
  };
  const getRange = () => {
    return calendarData[0].date_range_days;
  };

  const handleTimeSlotChange = (value: string) => {
    let data = { ...timeSlots[0], timeslot_length: value };
    dispatch(updateCalendarAndSlotsState(data));
  };
  const handleCapacity = (value: any) => {
    let data = { ...timeSlots[0], capacity_per_timeslot: +value };
    dispatch(updateCalendarAndSlotsState(data));
  };
  const handleRange = (value: any) => {
    let data = { ...timeSlots[0], date_range_days: +value };
    dispatch(updateCalendarAndSlotsState(data));
  };

  const timeSlotsArray = [];
  for (let i = 1; i < 13; i++) {
    timeSlotsArray.push(i);
  }

  return (
    <>
      <div className={classes.container}>
        <div className={classes.flatlistContainer}>
          <div className={classes.inputContainer}>
            <CustomDropdown
              isCalendarSelect={true}
              label={`${translations('time.slot')}*`}
              placeholder={getTimeSlot()}
              options={timeSlotsArray.map((value: number) => {
                const v = moment()
                  .utcOffset(0)
                  .set({ hour: 0, second: 0, minute: value * 5, millisecond: 0 })
                  .format('HH:mm:ss');
                return {
                  id: v,
                  label: v,
                };
              })}
              onChange={(e) => handleTimeSlotChange(e.target.value)}
              maxWidth="422px"
              dropdownStyle={{
                height: 36,
                marginTop: 5,
                marginLeft: 0,
                border: '1px solid #a8aec0',
              }}
              labelColor={'gray'}
            />
          </div>

          <div className={classes.inputContainer}>
            <div className={classes.text}>{translations('capacity.persons')}</div>
            <input
              type={'text'}
              placeholder={getCapacity()}
              className={classes.textContainer}
              value={getCapacity()}
              onChange={(e) => handleCapacity(e.target.value)}
            />
          </div>
          <div className={classes.inputContainer}>
            <div className={classes.text}>{translations('booking.range')}</div>
            <input
              type={'text'}
              placeholder={getRange()}
              className={classes.textContainer}
              value={getRange()}
              onChange={(e) => handleRange(e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerSlots;
